import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import { OrderKeys } from 'sections/LKSection/modules/OrderModule/data'

import { OrderItemStatusHeader } from '../OrderItemStatusHeader/OrderItemStatusHeader'

export const OrderStatusActivated = observer(() => {
  const { t } = useTranslation()

  const getKey = (key: string) => `${OrderKeys.orderItemPage}.${key}`

  return (
    <>
      <OrderItemStatusHeader
        type="success"
        title={`${t(getKey('Поздравляем'))}!`}
        subTitle={t(getKey('ПВЗ создан и активирован'))}
        isActive
      />
    </>
  )
})
